import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  paddingBottom: {
    paddingBottom: theme.spacing(3),
  },
  paddingTop: {
    paddingTop: theme.spacing(3),
  },
  ruleCardContainer: {},
  trashcanIcon: {
    fontSize: theme.spacing(1.5),
    marginRight: theme.spacing(1),
  },
  dragHandle: {
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    color: theme.palette.common.gray500,
    '&:active': {
      cursor: 'grabbing',
    },
  },
}));
